(function () {
  'use strict';

  /* @ngdoc object
   * @name user.marketplace
   * @description
   *
   */
  angular
    .module('user.marketplace', [
      'ui.router',
      'mlpMarketplace'
    ]);
}());
